import React from 'react';
import classNames from 'classnames';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';

import gettext from 'js-utils/gettext';

import { MAP_TYPE_LOCAL } from 'eventbrite_design_system/interactiveMap/constants';
import InteractiveMap from 'eventbrite_design_system/interactiveMap/InteractiveMap';
import { HAS_DOCUMENT } from 'eventbrite_design_system/utils/dom';
import Icon from 'eventbrite_design_system/icon/Icon';
import Button from 'eventbrite_design_system/button/Button';
import ArrowLeftSvg from 'eventbrite_design_system/iconography/icons/ArrowLeft';

import withSearchMapBase from './SearchMapBase';
import BBoxSearchButton from './BBoxSearchButton';
import InteractiveMapMarkerTooltipMobileWrapped from './interactiveMapMarker/InteractiveMapMarkerTooltipMobile';
import { GOOGLE_MAPS_CLIENT_KEY } from '../../constants';
import {
    SEARCH_MAP_OPTIONS,
    SEARCH_MAP_DESKTOP_MOBILE_PROPTYPES,
    MOBILE_MAP_FULL_SCREEN,
} from './constants';

import './SearchMapMobile.scss';

const SEARCH_MAP_OPTIONS_MOBILE = {
    ...SEARCH_MAP_OPTIONS,
    disableDefaultUI: true,
    gestureHandling: 'greedy',
};

const FullScreenMapHeader = ({ closeListView }) => (
    <div className="search-map--mobile--fullscreen__header-container">
        <div className="search-map--mobile--fullscreen__header">
            <Button onClick={closeListView} style="none">
                <Icon type={<ArrowLeftSvg />} />
            </Button>
            <div className="eds-text--center search-map--mobile--fullscreen__header__text">
                {gettext('Map View')}
            </div>
        </div>
    </div>
);

export const FullScreenMap = ({
    onClickOutsideMapMarker,
    propsForInteractiveMap,
    onClickBackButon,
    onSearchByBounds,
    markers,
    tooltipSelectedEventsIds,
    events,
    onSaveEvent,
    viewEventMapView,
    isAuthenticated,
    isFixed,
    markerRef,
    shouldShowListView,
    isLoading,
}) => {
    const selectedEvents = filter(events, ({ id }) =>
        includes(tooltipSelectedEventsIds, id),
    );

    return (
        <div>
            {isEmpty(tooltipSelectedEventsIds) && (
                <BBoxSearchButton
                    onClick={onSearchByBounds}
                    style={{
                        margin: '64px 0 0',
                        right: '50%',
                        transform: 'translateX(50%)',
                    }}
                />
            )}
            <InteractiveMap
                {...propsForInteractiveMap}
                googleMapsClient={GOOGLE_MAPS_CLIENT_KEY}
                mapType={MAP_TYPE_LOCAL}
                options={SEARCH_MAP_OPTIONS_MOBILE}
                height="100vh"
                width="100vw"
            >
                {markers}
            </InteractiveMap>
            <FullScreenMapHeader closeListView={onClickBackButon} />
            <InteractiveMapMarkerTooltipMobileWrapped
                selectedEvents={selectedEvents}
                numEvents={events.length}
                onSaveEvent={onSaveEvent}
                onClick={viewEventMapView}
                isAuthenticated={isAuthenticated}
                onClickOutside={onClickOutsideMapMarker}
                parentIsFixed={isFixed}
                markerRef={markerRef}
                shouldShowListView={shouldShowListView}
                isLoading={isLoading}
            />
        </div>
    );
};

export const ShowMapButton = ({ onShowMapClick }) => (
    <div className="eds-align--right">
        <Button className="search-map-mobile-overlay" onClick={onShowMapClick}>
            {gettext('Map')}
        </Button>
    </div>
);

export class SearchMapMobile extends React.PureComponent {
    static propTypes = SEARCH_MAP_DESKTOP_MOBILE_PROPTYPES;

    _lockMobileViewport(isLocked) {
        if (HAS_DOCUMENT) {
            const lockClass = 'search-map--mobile--fullscreen--lock';

            if (isLocked) {
                document.body.classList.add(lockClass);
            } else {
                document.body.classList.remove(lockClass);
            }
        }
    }

    _getViewState() {
        const {
            location: { hash },
        } = this.props;

        const isFullScreenMap = hash === MOBILE_MAP_FULL_SCREEN;

        this._lockMobileViewport(isFullScreenMap);

        return isFullScreenMap;
    }

    render() {
        const {
            onClickOutsideMapMarker,
            onMapClick,
            onBackButtonClick,
        } = this.props;

        const isFullScreenMap = this._getViewState();

        const sectionClasses = classNames('search-map', {
            'search-map--mobile--fullscreen': isFullScreenMap,
        });

        const Component = isFullScreenMap ? FullScreenMap : ShowMapButton;

        return (
            <section className={sectionClasses}>
                <Component
                    {...this.props}
                    onShowMapClick={onMapClick}
                    onClickOutsideMapMarker={onClickOutsideMapMarker}
                    onClickBackButon={onBackButtonClick}
                    shouldShowListView={isFullScreenMap}
                />
            </section>
        );
    }
}

export default withSearchMapBase(SearchMapMobile);
